import { FC, useMemo, useState, useCallback } from 'react'
import styles from 'components/features/future/FutureNetworthBreakdownModule/FutureNetworthBreakdownModule.styl'
import { FutureNetworthBreakdownTable } from 'components/features/future/FutureNetworthBreakdownTable/FutureNetworthBreakdownTable'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { networthBreakdownSelector, chartDefaultIndexSelector } from 'components/features/future/selectors'
import { FutureNetworthBreakdownChart } from 'components/features/future/FutureNetworthBreakdownChart/FutureNetworthBreakdownChart'
import { splitAndSortBreakdownDate } from 'components/features/future/helpers'
import { FutureLayersBar } from 'components/features/future/FutureLayersBar/FutureLayersBar'

type FutureNetworthBreakdownModuleProps = {

}

export const FutureNetworthBreakdownModule: FC<FutureNetworthBreakdownModuleProps> = (props) => {
  const {} = props

  const items = useStoreSelector(networthBreakdownSelector)
  const defaultIndex = useStoreSelector(chartDefaultIndexSelector)

  const [highlightIndex, setHighlightIndex] = useState(-1)
  const handleHighlightChange = useCallback<(index: number) => void>((index) => {
    setHighlightIndex(index)
  }, [])

  const item = useMemo(() => {
    if (!items) {
      return null
    }
    const index = highlightIndex !== -1 ? highlightIndex : defaultIndex
    return items[index]
  }, [items, highlightIndex, defaultIndex])

  const { assets, debts } = useMemo(() => {
    if (!item) {
      return { assets: null, debts: null }
    }

    return splitAndSortBreakdownDate(item)
  }, [item])

  return (
    <div className={ styles.futureNetworthBreakdownModule }>
      <FutureNetworthBreakdownChart onHighlightChange={ handleHighlightChange } />
      <FutureLayersBar />
      <div className={ styles.breakdown }>
        <div className={ styles.breakdownTable }>
          { assets && item && (
            <FutureNetworthBreakdownTable memberValues={ assets } ageDate={ item.date } type='assets' />
          )}
        </div>
        <div className={ styles.breakdownTable }>
          { debts && item && (
            <FutureNetworthBreakdownTable memberValues={ debts } ageDate={ item.date } type='debts' />
          )}
        </div>
      </div>
    </div>
  )
}
